//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "LogoSlider",
  components: {},
  props: {
    logosList: {
      type: Array,
      required: true,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: {
        arrows: false,
        pagination: false,
        focus: "center",
        autoWidth: true,
        autoplay: true,
        interval: 5000,
        pauseOnHover: true,
        resetProgress: true,
        rewind: true
      },
    };
  },
};
